import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { TROUBLESHOOTING_GUIDES_CRUD_ACTION_CREATORS } from '../actions/troubleshooting_guides_actions';
import FetchUtils from './fetch_utils';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { parseJSON } from './fetch_utils';
import { logoutSuccess } from '../actions/session_actions';

const fetchUtils = new FetchUtils();

export const troubleshootingGuidesRestCrudThunksForBuyer = new RestCrudThunks(
	'troubleshooting_guides',
	'troubleshooting_guides',
	'troubleshottingGuides',
	'troubleshottingGuides',
	TROUBLESHOOTING_GUIDES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'troubleshooting/'
);

export const troubleshootingGuidesRestCrudThunksForSupplier = new RestCrudThunks(
	'troubleshooting_guides',
	'troubleshooting_guides',
	'troubleshottingGuides',
	'troubleshottingGuides',
	TROUBLESHOOTING_GUIDES_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'troubleshooting/'
);

const patchUpdates = (urlSuffix) => (roleType) => (entity) => {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(TROUBLESHOOTING_GUIDES_CRUD_ACTION_CREATORS.updateStart(entity));

			const baseUrl = getBackendUri();
			const apiUrl = `/api/v1/${roleType}/troubleshooting/troubleshooting_guides/${entity.id}/${urlSuffix}`;

			fetchUtils
				.patch(
					baseUrl + apiUrl,
					Object.assign({
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: entity,
					})
				)
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(TROUBLESHOOTING_GUIDES_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					} else {
						dispatch(TROUBLESHOOTING_GUIDES_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(TROUBLESHOOTING_GUIDES_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject(d.message);
				});
		});
	};
};

export const updateTroubleshootingGuideAssocations = (roleType) =>
	patchUpdates('associations')(roleType);
export const publishTroubleshootingGuide = (roleType) => patchUpdates('publish')(roleType);
export const revertTroubleshootingGuide = (roleType) => patchUpdates('revert')(roleType);
